// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/icons/marevo-icon-arrow-downwards.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interface__group {
  cursor: pointer;
  width: 100%;
}
.interface__group__head {
  padding: 22px 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 0.5px solid rgba(98, 154, 51, 0.7);
}
.interface__group__head__param {
  cursor: pointer;
  color: #629A33;
  display: flex;
}
.interface__group__head__param::after {
  content: "";
  transition: all 0.3s;
  display: block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  height: 12px;
  width: 24px;
  margin-left: 10px;
}
.interface__group__head__param-rotated::after {
  transform: rotate(180deg) !important;
}
.interface__group__inputs {
  padding: 20px 3px 30px 0px;
}
.interface__group__inputs > :not(:last-child) {
  margin-bottom: 20px;
}

.interface__group:last-child {
  margin-bottom: 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/interface/interfaceItems/interfaceGroup/interfaceGroup.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,WAAA;AADF;AAGE;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,8BAAA;EACA,iDAAA;AADJ;AAGI;EACE,eAAA;EACA,cCZS;EDaT,aAAA;AADN;AAGM;EACE,WAAA;EACA,oBAAA;EACA,cAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;AADR;AAKI;EACE,oCAAA;AAHN;AAOE;EACE,0BAAA;AALJ;AAOI;EACE,mBAAA;AALN;;AAUA;EACE,mBAAA;AAPF","sourcesContent":["@use \"../../../../styles/variables\" as vars;\n\n.interface__group {\n  cursor: pointer;\n  width: 100%;\n\n  &__head {\n    padding: 22px 0;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    border-bottom: 0.5px solid rgba($color: vars.$second-color, $alpha: 0.7);\n\n    &__param {\n      cursor: pointer;\n      color: vars.$second-color;\n      display: flex;\n\n      &::after {\n        content: \"\";\n        transition: all 0.3s;\n        display: block;\n        background-image: url(/public/img/icons/marevo-icon-arrow-downwards.svg);\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        height: 12px;\n        width: 24px;\n        margin-left: 10px;\n      }\n    }\n\n    &__param-rotated::after {\n      transform: rotate(180deg) !important;\n    }\n  }\n\n  &__inputs {\n    padding: vars.$padding-vertical-group-inputs 3px 30px 0px;\n\n    & > :not(:last-child) {\n      margin-bottom: 20px;\n    }\n  }\n}\n\n.interface__group:last-child {\n  margin-bottom: 40px;\n}\n","$primary-color: #629A33;\n$secondary-color: #6c757d;\n$font-size-base: 16px;\n$second-color: #629A33;\n$second-color-1: #06aeef;\n$shadow-color: #47659314;\n$black-color:  #1A1A1A;\n$black-color-second: #3A3A3C;\n$white-color: #ffffff;\n$red-color: #ff214a;\n\n$margin-top-title-option: 10px;\n$padding-vertical-group-inputs: 20px;\n$width-interface: 39vw;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
